<template>
  <div class="lottery">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>随机抽签 / 摇号</span>
        <el-button style="float: right; padding: 3px 10px" type="text" @click="activeTab = 'lottery'">抽奖</el-button>
        <el-button style="float: right; padding: 3px 10px" type="text" @click="activeTab = 'group'">分组</el-button>
      </div>

      <!-- 抽奖模式 -->
      <div v-if="activeTab === 'lottery'">
        <el-input
          type="textarea"
          :rows="4"
          v-model="participantsText"
          placeholder="输入参与人员名单（用逗号分隔），例如：张三, 李四, 王五, 赵六"
          style="margin-bottom: 20px">
        </el-input>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-button type="primary" size="large" @click="startLottery" :disabled="isRunning || participants.length < 2">
              {{ isRunning ? '抽奖进行中...' : '开始抽奖' }}
            </el-button>
            <el-button @click="resetLottery" :disabled="isRunning">重置</el-button>
          </el-col>
          <el-col :span="12" v-if="winner">
            <div class="winner-display" v-if="winner">
              <span class="winner-label">中奖者：</span>
              <span class="winner-name">{{ winner }}</span>
            </div>
          </el-col>
        </el-row>

        <div v-if="isRunning" class="rolling-display">
          <div class="rolling-name">{{ rollingName }}</div>
        </div>

        <el-divider></el-divider>

        <h3>抽奖历史</h3>
        <el-table :data="history" style="width: 100%" stripe>
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="winner" label="中奖者" width="150"></el-table-column>
          <el-table-column prop="time" label="时间"></el-table-column>
        </el-table>
      </div>

      <!-- 分组模式 -->
      <div v-if="activeTab === 'group'">
        <el-input
          type="textarea"
          :rows="4"
          v-model="participantsText"
          placeholder="输入参与人员名单（用逗号分隔），例如：张三, 李四, 王五, 赵六"
          style="margin-bottom: 20px">
        </el-input>
        
        <el-row :gutter="20" style="margin-bottom: 20px">
          <el-col :span="8">
            <el-input-number v-model="groupCount" :min="2" :max="20" label="分组数量"></el-input-number>
          </el-col>
          <el-col :span="16">
            <el-button type="primary" @click="doGrouping" :disabled="participants.length < 2">开始分组</el-button>
            <el-button @click="resetGrouping">重置</el-button>
          </el-col>
        </el-row>

        <div v-if="groups.length > 0" class="groups-result">
          <el-row :gutter="20">
            <el-col :span="8" v-for="(group, index) in groups" :key="index" style="margin-bottom: 20px">
              <el-card class="group-card">
                <div slot="header" class="group-header">
                  <span>第 {{ index + 1 }} 组</span>
                  <el-tag size="small">{{ group.length }}人</el-tag>
                </div>
                <div class="group-members">
                  <div v-for="(member, i) in group" :key="i" class="member-item">
                    {{ member }}
                  </div>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'lottery',
  data () {
    return {
      activeTab: 'lottery',
      participantsText: '',
      isRunning: false,
      winner: '',
      rollingName: '',
      history: [],
      groupCount: 3,
      groups: [],
      rollingTimer: null
    }
  },
  computed: {
    participants () {
      if (!this.participantsText.trim()) return []
      return this.participantsText.split(/[,，]/).map(s => s.trim()).filter(s => s)
    }
  },
  methods: {
    startLottery () {
      if (this.participants.length < 2) {
        this.$message.warning('参与人员至少需要2人')
        return
      }
      this.isRunning = true
      this.winner = ''
      this.rollingName = this.participants[Math.floor(Math.random() * this.participants.length)]
      
      let count = 0
      const maxCount = 30
      this.rollingTimer = setInterval(() => {
        this.rollingName = this.participants[Math.floor(Math.random() * this.participants.length)]
        count++
        if (count >= maxCount) {
          clearInterval(this.rollingTimer)
          this.winner = this.rollingName
          this.isRunning = false
          this.history.unshift({
            winner: this.winner,
            time: new Date().toLocaleString()
          })
        }
      }, 80)
    },
    resetLottery () {
      this.participantsText = ''
      this.winner = ''
      this.history = []
    },
    doGrouping () {
      if (this.participants.length < 2) {
        this.$message.warning('参与人员至少需要2人')
        return
      }
      const shuffled = [...this.participants].sort(() => Math.random() - 0.5)
      const groupSize = Math.ceil(shuffled.length / this.groupCount)
      this.groups = []
      
      for (let i = 0; i < this.groupCount; i++) {
        const group = shuffled.slice(i * groupSize, (i + 1) * groupSize)
        if (group.length > 0) {
          this.groups.push(group)
        }
      }
    },
    resetGrouping () {
      this.participantsText = ''
      this.groups = []
    }
  },
  beforeDestroy () {
    if (this.rollingTimer) {
      clearInterval(this.rollingTimer)
    }
  }
}
</script>

<style scoped>
.lottery {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}
.box-card {
  max-width: 1400px;
  margin: 0 auto;
}
.rolling-display {
  margin: 40px 0;
  padding: 40px;
  text-align: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
}
.rolling-name {
  font-size: 48px;
  font-weight: bold;
  color: white;
  animation: pulse 0.5s infinite;
}
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}
.winner-display {
  padding: 20px;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  border-radius: 12px;
  color: white;
  text-align: center;
}
.winner-label {
  font-size: 16px;
}
.winner-name {
  font-size: 32px;
  font-weight: bold;
  margin-left: 10px;
}
.group-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}
.group-card >>> .el-card__header {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
}
.group-card >>> .el-card__body {
  color: white;
}
.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.group-members {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.member-item {
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/view/lottery.vue